import classNames from 'clsx';
import styles from '../../embed.style';
import type { VideoEmbedADT } from '../../type';

export function prezi(input: VideoEmbedADT): VideoEmbedADT {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host === 'prezi.com') {
    const pathname = input.pathname;
    const split = pathname.split('/');
    const id = split[1];
    if (!id) return input;
    return (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          frameBorder="0"
          width="100%"
          height="100%"
          src={`https://prezi.com/p/embed/${id}`}
          allow="autoplay; fullscreen"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  return input;
}
